import React, { Component } from 'react';
import './Doughnut.css';

export default class Doughnut extends Component {
    constructor(props) {
        super(props);
        // active tab index
        // const activeIndex = '';
        // const activeIndex = props.tabs.findIndex(({ active }) => active);
        this.state = {
            activeIndex: ''
        };
    }

    clickHandler = i => () => { this.setState({ activeIndex: i }); }

    render() {
        const { selectedDoughnut } = this.props;
        const { activeIndex } = this.state;
        const { selectedPathWayContainID } = this.props;


        /* Six worker's chart */

        const renderOnTheJobChartOfSixWorker = () => {
            return (
                <>
                    <div class="chart-layout-box">
                        <div class="svg-item job-donut">
                            <svg width="100%" height="290" viewBox="0 0 40 40" class="donut">
                                <circle class="donut-hole" cx="20" cy="20" r="15.91549430918954" fill="#003F72"></circle>
                                <circle class="donut-segment donut-segment-1" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5" stroke-dasharray="69 31" stroke-dashoffset="25"></circle>
                                <circle class="donut-segment donut-segment-main-2" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5" stroke-dasharray="69 31" stroke-dashoffset="25"></circle>
                                <circle class="donut-segment donut-segment-3" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5" stroke-dasharray="69 31" stroke-dashoffset="25"></circle>
                                <g class="donut-text donut-text-1">
                                    <text y="45%" transform="translate(0, 2)"><tspan x="50%" text-anchor="middle" class="donut-percent" fill="white">4500</tspan></text>
                                    <text y="53%" transform="translate(0, 2)"><tspan x="50%" text-anchor="middle" class="donut-data" fill="white">Hours on-the-job</tspan></text>
                                </g>
                                <g class="donut-text donut-text-2">
                                    <text transform="translate(0, 2)">
                                        <tspan x="11%" y="44%" text-anchor="middle" class="text-value">1000</tspan>
                                        <tspan x="11%" y="50%" text-anchor="middle" class="text-value">hours</tspan>
                                    </text>
                                </g>
                                <g class="donut-text donut-text-3">
                                    <text transform="translate(0, 2)">
                                        <tspan x="77%" y="16%" text-anchor="middle" class="text-value">1500</tspan>
                                        <tspan x="78%" y="22%" text-anchor="middle" class="text-value">hours</tspan>
                                    </text>
                                </g>
                                <g class="donut-text donut-text-3">
                                    <text transform="translate(0, 2)">
                                        <tspan x="60%" y="82%" text-anchor="middle" class="text-value">2000</tspan>
                                        <tspan x="60%" y="88%" text-anchor="middle" class="text-value">hours</tspan>
                                    </text>
                                </g>
                            </svg>
                            <svg width="100%" height="85" viewBox="0 0 339 77" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="16.5" cy="14.9707" r="8" fill="#F8981C"></circle>
                                <text y="53%" transform="translate(0, 2)"><tspan x="30%" y="25%" text-anchor="middle" class="donut-data-caption" fill="white">Term 1 Apprentice</tspan></text>
                                <circle cx="186.5" cy="14.9707" r="8" fill="white"></circle>
                                <text y="53%" transform="translate(0, 2)"><tspan x="80%" y="25%" text-anchor="middle" class="donut-data-caption" fill="white">Term 2 Apprentice</tspan></text>
                                <circle cx="103" cy="45.9707" r="8" fill="#EDB669"></circle>
                                <text y="38%" transform="translate(0, 2)"><tspan x="55%" y="65%" text-anchor="middle" class="donut-data-caption" fill="white">Term 3 Apprentice</tspan></text>
                            </svg>
                        </div>
                    </div>
                </>
            )

        }

        const renderInSchoolChartOfSixWorker = () => {
            return (
                <>
                    <div class="chart-layout-box">
                        <div class="svg-item">
                            <svg width="100%" height="100%" viewBox="0 0 40 40" class="donut">
                                <circle class="donut-hole" cx="20" cy="20" r="15.91549430918954" fill="#003F72"></circle>
                                <circle class="donut-ring" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5" stroke-dashoffset="25"></circle>
                                <circle class="donut-segment donut-segment-5 donut-segment-51" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5" stroke-dasharray="69 31" stroke-dashoffset="-10"></circle>
                                <g class="donut-text donut-text-1">
                                    <text y="45%" transform="translate(0, 2)"><tspan x="50%" text-anchor="middle" class="donut-percent" fill="white">480</tspan></text>
                                    <text y="53%" transform="translate(0, 2)"><tspan x="50%" text-anchor="middle" class="donut-data" fill="white">Hours in-school</tspan></text>
                                </g>
                                <g class="donut-text donut-text-2">
                                    <text transform="translate(0, 2)"><tspan x="86%" y="30%" text-anchor="middle" class="text-value">40%</tspan></text>
                                </g>
                                <g class="donut-text donut-text-3">
                                    <text transform="translate(0, 2)"><tspan x="12%" y="60%" text-anchor="middle" class="text-value">60%</tspan></text>
                                </g>
                            </svg>
                            <svg class="donut-caption" width="100%" height="100%" viewBox="0 0 287 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="16" cy="14.9941" r="8" fill="#F8981C"></circle>
                                <text><tspan x="33%" y="70%" text-anchor="middle" class="text-value-school" fill="white">In the classroom</tspan></text>
                                <circle cx="178" cy="14.9941" r="8" fill="white"></circle>
                                <text><tspan x="83%" y="70%" text-anchor="middle" class="text-value-school" fill="white">On the tools</tspan></text>
                            </svg>
                        </div>
                    </div>
                </>
            )
        }

        const renderSixWorkerDetailsControls = () => {
            return (
                <>
                    <div className='button-grp-layout'>
                        {
                            (activeIndex !== 'In-School' && activeIndex !== 'OnTheJob') &&
                            <>
                                <button className='in-school-btn' onClick={this.clickHandler('In-School')}>
                                    In-school <img src="/image/btn-arrow-chart.svg" alt="Arrow"></img>
                                </button>
                                <button className='in-job-btn' onClick={this.clickHandler('OnTheJob')}>
                                    On-the-job <img src="/image/btn-arrow-chart.svg" alt="Arrow"></img>
                                </button>
                            </>
                        }
                        <div>
                            {
                                activeIndex === 'In-School' &&
                                <>
                                    <div className='back-btn-hours-box'>
                                        <button className='in-back-btn' onClick={this.clickHandler('')}>
                                            <img src="/image/btn-arrow-chart.svg" alt="Arrow" /> Back
                                        </button>
                                    </div>
                                    {renderInSchoolChartOfSixWorker()}
                                </>
                            }
                            {
                                activeIndex === 'OnTheJob' &&
                                <>
                                    <div className='back-btn-hours-box'>
                                        <button className='in-back-btn' onClick={this.clickHandler('')}>
                                            <img src="/image/btn-arrow-chart.svg" alt="Arrow" /> Back
                                        </button>
                                    </div>
                                    {renderOnTheJobChartOfSixWorker()}
                                </>
                            }
                        </div>
                    </div>

                    {/* chart code */}
                    {
                        (activeIndex !== 'In-School' && activeIndex !== 'OnTheJob') &&
                        <>
                            <div className='chart-layout-box'>
                                <div class="svg-item apprenticeship-donut">
                                    <svg width="100%" height="353" viewBox="0 0 40 40" class="donut">
                                        <circle class="donut-hole" cx="20" cy="20" r="15.91549430918954" fill="#003F72"></circle>
                                        <circle class="donut-ring" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5"></circle>
                                        <circle class="donut-segment donut-segment-2" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5" stroke-dasharray="69 31" stroke-dashoffset="25"></circle>
                                        <g class="donut-text donut-text-1">
                                            <text y="45%" transform="translate(0, 2)">
                                                <tspan x="50%" text-anchor="middle" class="donut-percent" fill="white">4980</tspan>
                                            </text>
                                            <text y="53%" transform="translate(0, 2)">
                                                <tspan x="50%" text-anchor="middle" class="donut-data" fill="white">Apprenticeship -</tspan>
                                                <tspan x="50%" y="60%" text-anchor="middle" class="donut-data" fill="white">Total Hours</tspan>
                                            </text>
                                        </g>
                                        <g class="donut-text donut-text-2">
                                            <text transform="translate(0, 2)"><tspan x="31%" y="8%" text-anchor="middle" class="text-value">480</tspan><tspan x="31%" y="15%" text-anchor="middle" class="text-value">hours</tspan></text>
                                        </g>
                                        <g class="donut-text donut-text-3">
                                            <text transform="translate(0, 2)"><tspan x="68%" y="79%" text-anchor="middle" class="text-value">4500</tspan><tspan x="68%" y="86%" text-anchor="middle" class="text-value">hours</tspan></text>
                                        </g>
                                    </svg>
                                </div>
                            </div>
                        </>
                    }
                </>
            )
        }

        /* Fifth worker's chart */

        const renderOnTheJobChartOfFifthWorker = () => {
            return (
                <>
                    <div class="chart-layout-box">
                        <div class="svg-item job-donut">
                            <svg width="100%" height="290" viewBox="0 0 40 40" class="donut">
                                <circle class="donut-hole" cx="20" cy="20" r="15.91549430918954" fill="#003F72"></circle>
                                <circle class="donut-segment donut-segment-1" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5" stroke-dasharray="69 31" stroke-dashoffset="25"></circle>
                                <circle class="donut-segment donut-segment-main-3" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5" stroke-dasharray="69 31" stroke-dashoffset="25"></circle>
                                <g class="donut-text donut-text-1">
                                    <text y="45%" transform="translate(0, 2)"><tspan x="50%" text-anchor="middle" class="donut-percent" fill="white">{selectedPathWayContainID == 2 ? 2400 : 2897}</tspan></text>
                                    <text y="53%" transform="translate(0, 2)"><tspan x="50%" text-anchor="middle" class="donut-data" fill="white">Hours on-the-job</tspan></text>
                                </g>
                                <g class="donut-text donut-text-2">
                                    <text transform="translate(0, 2)">
                                        <tspan x="10%" y="45%" text-anchor="middle" class="text-value">{selectedPathWayContainID == 2 ? 1200 : 1448}</tspan>
                                        <tspan x="10%" y="51%" text-anchor="middle" class="text-value">hours</tspan>
                                    </text>
                                </g>
                                <g class="donut-text donut-text-3">
                                    <text transform="translate(0, 2)">
                                        <tspan x="90%" y="45%" text-anchor="middle" class="text-value">{selectedPathWayContainID == 2 ? 1200 : 1448}</tspan>
                                        <tspan x="90%" y="50%" text-anchor="middle" class="text-value">hours</tspan>
                                    </text>
                                </g>
                            </svg>
                            <svg width="100%" height="85" viewBox="0 0 339 77" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="16.5" cy="42.9707" r="8" fill="#F8981C"></circle>
                                <text y="69%" transform="translate(0, 2)"><tspan x="30%" y="60%" text-anchor="middle" class="donut-data-caption" fill="white">Term 1 Apprentice</tspan></text>
                                <circle cx="186.5" cy="42.9707" r="8" fill="white"></circle>
                                <text y="53%" transform="translate(0, 2)"><tspan x="80%" y="60%" text-anchor="middle" class="donut-data-caption" fill="white">Term 2 Apprentice</tspan></text>
                            </svg>
                        </div>
                    </div>
                </>
            )

        }

        const renderInSchoolChartOfFifthWorker = () => {
            return (
                <>
                    <div class="chart-layout-box">
                        <div class="svg-item">
                            <svg width="100%" height="100%" viewBox="0 0 40 40" class="donut">
                                <circle class="donut-hole" cx="20" cy="20" r="15.91549430918954" fill="#003F72"></circle>
                                <circle class="donut-ring" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5" stroke-dashoffset="25"></circle>
                                <circle class="donut-segment donut-segment-5 donut-segment-51" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5" stroke-dasharray="69 31" stroke-dashoffset="-10"></circle>
                                <g class="donut-text donut-text-1">
                                    <text y="45%" transform="translate(0, 2)"><tspan x="50%" text-anchor="middle" class="donut-percent" fill="white">{selectedPathWayContainID == 2 ? 480 : 103}</tspan></text>
                                    <text y="53%" transform="translate(0, 2)"><tspan x="50%" text-anchor="middle" class="donut-data" fill="white">Hours in-school</tspan></text>
                                </g>
                                <g class="donut-text donut-text-2">
                                    <text transform="translate(0, 2)"><tspan x="86%" y="30%" text-anchor="middle" class="text-value">40%</tspan></text>
                                </g>
                                <g class="donut-text donut-text-3">
                                    <text transform="translate(0, 2)"><tspan x="12%" y="60%" text-anchor="middle" class="text-value">60%</tspan></text>
                                </g>
                            </svg>
                            <svg class="donut-caption" width="100%" height="100%" viewBox="0 0 287 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="16" cy="14.9941" r="8" fill="#F8981C"></circle>
                                <text><tspan x="33%" y="70%" text-anchor="middle" class="text-value-school" fill="white">In the classroom</tspan></text>
                                <circle cx="178" cy="14.9941" r="8" fill="white"></circle>
                                <text><tspan x="83%" y="70%" text-anchor="middle" class="text-value-school" fill="white">On the tools</tspan></text>
                            </svg>
                        </div>
                    </div>
                </>
            )
        }

        const renderFifthWorkerDetailsControls = () => {
            return (
                <>
                    <div className='button-grp-layout'>
                        {
                            (activeIndex !== 'In-School' && activeIndex !== 'OnTheJob') &&
                            <>
                                <button className='in-school-btn' onClick={this.clickHandler('In-School')}>
                                    In-school <img src="/image/btn-arrow-chart.svg" alt="Arrow"></img>
                                </button>
                                <button className='in-job-btn' onClick={this.clickHandler('OnTheJob')}>
                                    On-the-job <img src="/image/btn-arrow-chart.svg" alt="Arrow"></img>
                                </button>
                            </>
                        }
                        <div>
                            {
                                activeIndex === 'In-School' &&
                                <>
                                    <div className='back-btn-hours-box'>
                                        <button className='in-back-btn' onClick={this.clickHandler('')}>
                                            <img src="/image/btn-arrow-chart.svg" alt="Arrow" /> Back
                                        </button>
                                    </div>
                                    {renderInSchoolChartOfFifthWorker()}
                                </>
                            }
                            {
                                activeIndex === 'OnTheJob' &&
                                <>
                                    <div className='back-btn-hours-box'>
                                        <button className='in-back-btn' onClick={this.clickHandler('')}>
                                            <img src="/image/btn-arrow-chart.svg" alt="Arrow" /> Back
                                        </button>
                                    </div>
                                    {renderOnTheJobChartOfFifthWorker()}
                                </>
                            }
                        </div>
                    </div>

                    {/* chart code */}
                    {
                        (activeIndex !== 'In-School' && activeIndex !== 'OnTheJob') &&
                        <>
                            <div className='chart-layout-box'>
                                <div class="svg-item apprenticeship-donut">
                                    {
                                        selectedPathWayContainID==2?<><svg width="100%" height="353" viewBox="0 0 40 40" class="donut">
                                        <circle class="donut-hole" cx="20" cy="20" r="15.91549430918954" fill="#003F72"></circle>
                                        <circle class="donut-ring" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5"></circle>
                                        <circle class="donut-segment donut-segment-2" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5" stroke-dasharray="69 31" stroke-dashoffset="25"></circle>
                                        <g class="donut-text donut-text-1">
                                            <text y="45%" transform="translate(0, 2)">
                                                <tspan x="50%" text-anchor="middle" class="donut-percent" fill="white">{selectedPathWayContainID == 2 ? 2880 : 3000}</tspan>
                                            </text>
                                            <text y="53%" transform="translate(0, 2)">
                                                <tspan x="50%" text-anchor="middle" class="donut-data" fill="white">Apprenticeship -</tspan>
                                                <tspan x="50%" y="60%" text-anchor="middle" class="donut-data" fill="white">Total Hours</tspan>
                                            </text>
                                        </g>
                                        <g class="donut-text donut-text-2">
                                            <text transform="translate(0, 2)"><tspan x="30%" y="9%" text-anchor="middle" class="text-value">{selectedPathWayContainID == 2 ? 480 : 103}</tspan><tspan x="30%" y="14%" text-anchor="middle" class="text-value">hours</tspan></text>
                                        </g>
                                        <g class="donut-text donut-text-3">
                                            <text transform="translate(0, 2)"><tspan x="68%" y="79%" text-anchor="middle" class="text-value">{selectedPathWayContainID == 2 ? 2400 : 2897}</tspan><tspan x="68%" y="86%" text-anchor="middle" class="text-value">hours</tspan></text>
                                        </g>
                                    </svg></>:<><svg width="100%" height="353" viewBox="0 0 40 40" class="donut">
                                        <circle class="donut-hole" cx="20" cy="20" r="15.91549430918954" fill="#003F72"></circle>
                                        <circle class="donut-ring" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5"></circle>
                                        <circle class="donut-segment donut-segment-new" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5" stroke-dasharray="69 31" stroke-dashoffset="25"></circle>
                                        <g class="donut-text donut-text-1">
                                            <text y="45%" transform="translate(0, 2)">
                                                <tspan x="50%" text-anchor="middle" class="donut-percent" fill="white">{selectedPathWayContainID == 2 ? 2880 : 3000}</tspan>
                                            </text>
                                            <text y="53%" transform="translate(0, 2)">
                                                <tspan x="50%" text-anchor="middle" class="donut-data" fill="white">Apprenticeship -</tspan>
                                                <tspan x="50%" y="60%" text-anchor="middle" class="donut-data" fill="white">Total Hours</tspan>
                                            </text>
                                        </g>
                                        <g class="donut-text donut-text-2">
                                            <text transform="translate(0, 2)"><tspan x="47%" y="4%" text-anchor="middle" class="text-value">{selectedPathWayContainID == 2 ? 480 : 103}</tspan><tspan x="47%" y="10%" text-anchor="middle" class="text-value">hours</tspan></text>
                                        </g>
                                        <g class="donut-text donut-text-3">
                                            <text transform="translate(0, 2)"><tspan x="68%" y="79%" text-anchor="middle" class="text-value">{selectedPathWayContainID == 2 ? 2400 : 2897}</tspan><tspan x="68%" y="86%" text-anchor="middle" class="text-value">hours</tspan></text>
                                        </g>
                                    </svg></>
                                    }
                                    
                                </div>
                            </div>
                        </>
                    }
                </>
            )
        }

        /* Forth worker's chart */

        const renderOnTheJobChartOfForthWorker = () => {
            return (
                <>
                    <div class="chart-layout-box">
                        <div class="svg-item job-donut job-donut-one">
                            <svg width="100%" height="100%" viewBox="0 0 40 40" class="donut"><circle class="donut-hole" cx="20" cy="20" r="15.91549430918954" fill="#003F72"></circle><circle class="donut-segment donut-segment-1" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5" stroke-dasharray="100, 30" stroke-dashoffset="25"></circle><circle class="donut-segment donut-segment-main-2" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5" stroke-dasharray="45, 50" stroke-dashoffset="25"></circle><circle class="donut-segment donut-segment-3" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5" stroke-dasharray="69 31" stroke-dashoffset="25"></circle><g class="donut-text donut-text-1"><text y="45%" transform="translate(0, 2)"><tspan x="50%" text-anchor="middle" class="donut-percent" fill="white">2400</tspan></text><text y="53%" transform="translate(0, 2)"><tspan x="50%" text-anchor="middle" class="donut-data" fill="white">Hours on-the-job</tspan></text></g><g class="donut-text donut-text-2"><text transform="translate(0, 2)"><tspan x="13%" y="30%" text-anchor="middle" class="text-value">800</tspan><tspan x="12%" y="37%" text-anchor="middle" class="text-value">hours</tspan></text></g><g class="donut-text donut-text-3"><text transform="translate(0, 2)"><tspan x="83%" y="21%" text-anchor="middle" class="text-value">800</tspan><tspan x="83%" y="27%" text-anchor="middle" class="text-value">hours</tspan></text></g><g class="donut-text donut-text-4"><text transform="translate(4, 2)"><tspan x="50%" y="84%" text-anchor="middle" class="text-value">800</tspan><tspan x="50%" y="90%" text-anchor="middle" class="text-value">hours</tspan></text></g></svg>
                            <svg class="donut-bottom-text" width="auto" height="100%" viewBox="0 0 339 99" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="16.5" cy="45.9707" r="8" fill="#F8981C"></circle>
                                <text y="53%" transform="translate(0, 2)"><tspan x="30%" y="49%" text-anchor="middle" class="donut-data-caption" fill="white">Term 1 Apprentice</tspan></text>
                                <circle cx="186.5" cy="46.9707" r="8" fill="white"></circle>
                                <text y="53%" transform="translate(0, 2)"><tspan x="80%" y="50%" text-anchor="middle" class="donut-data-caption" fill="white">Term 2 Apprentice</tspan></text>
                                <circle cx="103" cy="80.9707" r="8" fill="#f9b660"></circle>
                                <text y="80%" transform="translate(0, 2)"><tspan x="55%" y="84.9707" text-anchor="middle" class="donut-data-caption" fill="white">Term 3 Apprentice</tspan></text>
                            </svg>
                        </div>
                    </div>
                </>
            )

        }

        const renderInSchoolChartOfForthWorker = () => {
            return (
                <>
                    <div class="chart-layout-box">
                        <div class="svg-item">
                            <svg width="100%" height="100%" viewBox="0 0 40 40" class="donut">
                                <circle class="donut-hole" cx="20" cy="20" r="15.91549430918954" fill="#003F72"></circle>
                                <circle class="donut-ring" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5" stroke-dashoffset="25"></circle>
                                <circle class="donut-segment donut-segment-5 donut-segment-51" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5" stroke-dasharray="69 31" stroke-dashoffset="-10"></circle>
                                <g class="donut-text donut-text-1">
                                    <text y="45%" transform="translate(0, 2)"><tspan x="50%" text-anchor="middle" class="donut-percent" fill="white">480</tspan></text>
                                    <text y="53%" transform="translate(0, 2)"><tspan x="50%" text-anchor="middle" class="donut-data" fill="white">Hours in-school</tspan></text>
                                </g>
                                <g class="donut-text donut-text-2">
                                    <text transform="translate(0, 2)"><tspan x="86%" y="30%" text-anchor="middle" class="text-value">40%</tspan></text>
                                </g>
                                <g class="donut-text donut-text-3">
                                    <text transform="translate(0, 2)"><tspan x="12%" y="60%" text-anchor="middle" class="text-value">60%</tspan></text>
                                </g>
                            </svg>
                            <svg class="donut-caption" width="100%" height="100%" viewBox="0 0 287 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="16" cy="14.9941" r="8" fill="#F8981C"></circle>
                                <text><tspan x="33%" y="70%" text-anchor="middle" class="text-value-school" fill="white">In the classroom</tspan></text>
                                <circle cx="178" cy="14.9941" r="8" fill="white"></circle>
                                <text><tspan x="83%" y="70%" text-anchor="middle" class="text-value-school" fill="white">On the tools</tspan></text>
                            </svg>
                        </div>
                    </div>
                </>
            )
        }

        const renderForthWorkerDetailsControls = () => {
            return (
                <>
                    <div className='button-grp-layout'>
                        {
                            (activeIndex !== 'In-School' && activeIndex !== 'OnTheJob') &&
                            <>
                                <button className='in-school-btn' onClick={this.clickHandler('In-School')}>
                                    In-school <img src="/image/btn-arrow-chart.svg" alt="Arrow"></img>
                                </button>
                                <button className='in-job-btn' onClick={this.clickHandler('OnTheJob')}>
                                    On-the-job <img src="/image/btn-arrow-chart.svg" alt="Arrow"></img>
                                </button>
                            </>
                        }
                        <div>
                            {
                                activeIndex === 'In-School' &&
                                <>
                                    <div className='back-btn-hours-box'>
                                        <button className='in-back-btn' onClick={this.clickHandler('')}>
                                            <img src="/image/btn-arrow-chart.svg" alt="Arrow" /> Back
                                        </button>
                                    </div>
                                    {renderInSchoolChartOfForthWorker()}
                                </>
                            }
                            {
                                activeIndex === 'OnTheJob' &&
                                <>
                                    <div className='back-btn-hours-box'>
                                        <button className='in-back-btn' onClick={this.clickHandler('')}>
                                            <img src="/image/btn-arrow-chart.svg" alt="Arrow" /> Back
                                        </button>
                                    </div>
                                    {renderOnTheJobChartOfForthWorker()}
                                </>
                            }
                        </div>
                    </div>

                    {/* chart code */}
                    {
                        (activeIndex !== 'In-School' && activeIndex !== 'OnTheJob') &&
                        <>
                            <div className='chart-layout-box'>
                                <div class="svg-item apprenticeship-donut">
                                    <svg width="100%" height="353" viewBox="0 0 40 40" class="donut">
                                        <circle class="donut-hole" cx="20" cy="20" r="15.91549430918954" fill="#003F72"></circle>
                                        <circle class="donut-ring" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5"></circle>
                                        <circle class="donut-segment donut-segment-2" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5" stroke-dasharray="69 31" stroke-dashoffset="25"></circle>
                                        <g class="donut-text donut-text-1">
                                            <text y="45%" transform="translate(0, 2)">
                                                <tspan x="50%" text-anchor="middle" class="donut-percent" fill="white">2880</tspan>
                                            </text>
                                            <text y="53%" transform="translate(0, 2)">
                                                <tspan x="50%" text-anchor="middle" class="donut-data" fill="white">Apprenticeship -</tspan>
                                                <tspan x="50%" y="60%" text-anchor="middle" class="donut-data" fill="white">Total Hours</tspan>
                                            </text>
                                        </g>
                                        <g class="donut-text donut-text-2">
                                            <text transform="translate(0, 2)"><tspan x="31%" y="8%" text-anchor="middle" class="text-value">480</tspan><tspan x="31%" y="15%" text-anchor="middle" class="text-value">hours</tspan></text>
                                        </g>
                                        <g class="donut-text donut-text-3">
                                            <text transform="translate(0, 2)"><tspan x="68%" y="79%" text-anchor="middle" class="text-value">2400</tspan><tspan x="68%" y="86%" text-anchor="middle" class="text-value">hours</tspan></text>
                                        </g>
                                    </svg>
                                </div>
                            </div>
                        </>
                    }
                </>
            )
        }

        /* Third worker's chart */

        const renderOnTheJobChartOfThirdWorker = () => {
            return (
                <>
                    <div class="chart-layout-box">
                        <div class="svg-item job-donut job-donut-one">
                            <svg width="100%" height="100%" viewBox="0 0 40 40" class="donut"><circle class="donut-hole" cx="20" cy="20" r="15.91549430918954" fill="#003F72"></circle><circle class="donut-segment donut-segment-1" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5" stroke-dasharray="100, 30" stroke-dashoffset="25"></circle><circle class="donut-segment donut-segment-main-2" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5" stroke-dasharray="45, 50" stroke-dashoffset="25"></circle><circle class="donut-segment donut-segment-3" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5" stroke-dasharray="69 31" stroke-dashoffset="25"></circle><g class="donut-text donut-text-1"><text y="45%" transform="translate(0, 2)"><tspan x="50%" text-anchor="middle" class="donut-percent" fill="white">2400</tspan></text><text y="53%" transform="translate(0, 2)"><tspan x="50%" text-anchor="middle" class="donut-data" fill="white">Hours on-the-job</tspan></text></g><g class="donut-text donut-text-2"><text transform="translate(0, 2)"><tspan x="13%" y="30%" text-anchor="middle" class="text-value">800</tspan><tspan x="12%" y="37%" text-anchor="middle" class="text-value">hours</tspan></text></g><g class="donut-text donut-text-3"><text transform="translate(0, 2)"><tspan x="83%" y="21%" text-anchor="middle" class="text-value">800</tspan><tspan x="83%" y="27%" text-anchor="middle" class="text-value">hours</tspan></text></g><g class="donut-text donut-text-4"><text transform="translate(4, 2)"><tspan x="50%" y="84%" text-anchor="middle" class="text-value">800</tspan><tspan x="50%" y="90%" text-anchor="middle" class="text-value">hours</tspan></text></g></svg>
                            <svg class="donut-bottom-text" width="auto" height="100%" viewBox="0 0 339 99" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="16.5" cy="45.9707" r="8" fill="#F8981C"></circle>
                                <text y="53%" transform="translate(0, 2)"><tspan x="30%" y="49%" text-anchor="middle" class="donut-data-caption" fill="white">Term 1 Apprentice</tspan></text>
                                <circle cx="186.5" cy="46.9707" r="8" fill="white"></circle>
                                <text y="53%" transform="translate(0, 2)"><tspan x="80%" y="50%" text-anchor="middle" class="donut-data-caption" fill="white">Term 2 Apprentice</tspan></text>
                                <circle cx="103" cy="80.9707" r="8" fill="#f9b660"></circle>
                                <text y="80%" transform="translate(0, 2)"><tspan x="55%" y="84.9707" text-anchor="middle" class="donut-data-caption" fill="white">Term 3 Apprentice</tspan></text>
                            </svg>
                        </div>
                    </div>
                </>
            )

        }

        const renderInSchoolChartOfThirdWorker = () => {
            return (
                <>
                    <div class="chart-layout-box">
                        <div class="svg-item">
                            <svg width="100%" height="100%" viewBox="0 0 40 40" class="donut">
                                <circle class="donut-hole" cx="20" cy="20" r="15.91549430918954" fill="#003F72"></circle>
                                <circle class="donut-ring" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5" stroke-dashoffset="25"></circle>
                                <circle class="donut-segment donut-segment-5 donut-segment-51" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5" stroke-dasharray="69 31" stroke-dashoffset="-10"></circle>
                                <g class="donut-text donut-text-1">
                                    <text y="45%" transform="translate(0, 2)"><tspan x="50%" text-anchor="middle" class="donut-percent" fill="white">480</tspan></text>
                                    <text y="53%" transform="translate(0, 2)"><tspan x="50%" text-anchor="middle" class="donut-data" fill="white">Hours in-school</tspan></text>
                                </g>
                                <g class="donut-text donut-text-2">
                                    <text transform="translate(0, 2)"><tspan x="86%" y="30%" text-anchor="middle" class="text-value">40%</tspan></text>
                                </g>
                                <g class="donut-text donut-text-3">
                                    <text transform="translate(0, 2)"><tspan x="12%" y="60%" text-anchor="middle" class="text-value">60%</tspan></text>
                                </g>
                            </svg>
                            <svg class="donut-caption" width="100%" height="100%" viewBox="0 0 287 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="16" cy="14.9941" r="8" fill="#F8981C"></circle>
                                <text><tspan x="33%" y="70%" text-anchor="middle" class="text-value-school" fill="white">In the classroom</tspan></text>
                                <circle cx="178" cy="14.9941" r="8" fill="white"></circle>
                                <text><tspan x="83%" y="70%" text-anchor="middle" class="text-value-school" fill="white">On the tools</tspan></text>
                            </svg>
                        </div>
                    </div>
                </>
            )
        }

        const renderThirdWorkerDetailsControls = () => {
            return (
                <>
                    <div className='button-grp-layout'>
                        {
                            (activeIndex !== 'In-School' && activeIndex !== 'OnTheJob') &&
                            <>
                                <button className='in-school-btn' onClick={this.clickHandler('In-School')}>
                                    In-school <img src="/image/btn-arrow-chart.svg" alt="Arrow"></img>
                                </button>
                                <button className='in-job-btn' onClick={this.clickHandler('OnTheJob')}>
                                    On-the-job <img src="/image/btn-arrow-chart.svg" alt="Arrow"></img>
                                </button>
                            </>
                        }
                        <div>
                            {
                                activeIndex === 'In-School' &&
                                <>
                                    <div className='back-btn-hours-box'>
                                        <button className='in-back-btn' onClick={this.clickHandler('')}>
                                            <img src="/image/btn-arrow-chart.svg" alt="Arrow" /> Back
                                        </button>
                                    </div>
                                    {renderInSchoolChartOfThirdWorker()}
                                </>
                            }
                            {
                                activeIndex === 'OnTheJob' &&
                                <>
                                    <div className='back-btn-hours-box'>
                                        <button className='in-back-btn' onClick={this.clickHandler('')}>
                                            <img src="/image/btn-arrow-chart.svg" alt="Arrow" /> Back
                                        </button>
                                    </div>
                                    {renderOnTheJobChartOfThirdWorker()}
                                </>
                            }
                        </div>
                    </div>

                    {/* chart code */}
                    {
                        (activeIndex !== 'In-School' && activeIndex !== 'OnTheJob') &&
                        <>
                            <div className='chart-layout-box'>
                                <div class="svg-item apprenticeship-donut">
                                    <svg width="100%" height="353" viewBox="0 0 40 40" class="donut">
                                        <circle class="donut-hole" cx="20" cy="20" r="15.91549430918954" fill="#003F72"></circle>
                                        <circle class="donut-ring" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5"></circle>
                                        <circle class="donut-segment donut-segment-2" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5" stroke-dasharray="69 31" stroke-dashoffset="25"></circle>
                                        <g class="donut-text donut-text-1">
                                            <text y="45%" transform="translate(0, 2)">
                                                <tspan x="50%" text-anchor="middle" class="donut-percent" fill="white">2880</tspan>
                                            </text>
                                            <text y="53%" transform="translate(0, 2)">
                                                <tspan x="50%" text-anchor="middle" class="donut-data" fill="white">Apprenticeship -</tspan>
                                                <tspan x="50%" y="60%" text-anchor="middle" class="donut-data" fill="white">Total Hours</tspan>
                                            </text>
                                        </g>
                                        <g class="donut-text donut-text-2">
                                            <text transform="translate(0, 2)"><tspan x="31%" y="8%" text-anchor="middle" class="text-value">480</tspan><tspan x="31%" y="15%" text-anchor="middle" class="text-value">hours</tspan></text>
                                        </g>
                                        <g class="donut-text donut-text-3">
                                            <text transform="translate(0, 2)"><tspan x="68%" y="79%" text-anchor="middle" class="text-value">2400</tspan><tspan x="68%" y="86%" text-anchor="middle" class="text-value">hours</tspan></text>
                                        </g>
                                    </svg>
                                </div>
                            </div>
                        </>
                    }
                </>
            )
        }

        /* Second worker's chart */

        const renderOnTheJobChartOfSecondWorker = () => {
            return (
                <>
                    <div className='chart-layout-box'>
                        <div class="svg-item job-donut second-user-donut-mobile">
                            <svg width="100%" height="260" viewBox="0 0 40 40" class="donut">
                                <circle class="donut-hole" cx="20" cy="20" r="15.91549430918954" fill="#003F72"></circle>
                                <circle class="donut-segment precast-donut-segment-1" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5" stroke-dasharray="24, 52" stroke-dashoffset="25"></circle>
                                {/* <circle class="donut-segment precast-donut-segment-2" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5" stroke-dasharray="17, 42" stroke-dashoffset="25"></circle> */}
                                <circle class="donut-segment precast-donut-segment-3" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5" stroke-dasharray="34, 78" stroke-dashoffset="25"></circle>
                                <circle class="donut-segment precast-donut-segment-4" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5" stroke-dasharray="64, 90" stroke-dashoffset="25"></circle>
                                <circle class="donut-segment precast-donut-segment-5" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5" stroke-dasharray="41, 90" stroke-dashoffset="25"></circle>
                                <g class="donut-text donut-text-1">
                                    <text y="45%" transform="translate(0, 2)">
                                        <tspan x="50%" text-anchor="middle" class="donut-percent" fill="white">3500</tspan>
                                    </text>
                                    <text y="53%" transform="translate(0, 2)">
                                        <tspan x="50%" text-anchor="middle" class="donut-data" fill="white">Hours on-the-job</tspan>
                                    </text>
                                </g>
                                <g class="donut-text donut-small-text donut-text-2">
                                    <text transform="translate(0, 2)"><tspan x="21%" y="16%" text-anchor="middle" class="text-value">1100</tspan><tspan x="21%" y="21%" text-anchor="middle" class="text-value">hours</tspan></text>
                                </g>
                                <g class="donut-text donut-small-text donut-text-3">
                                    <text transform="translate(0, 2)"><tspan x="84%" y="63%" text-anchor="middle" class="text-value">800</tspan><tspan x="84%" y="69%" text-anchor="middle" class="text-value">hours</tspan></text>
                                </g>
                                <g class="donut-text donut-small-text donut-text-3">
                                    <text transform="translate(0, 2)"><tspan x="78%" y="16%" text-anchor="middle" class="text-value">800</tspan><tspan x="78%" y="22%" text-anchor="middle" class="text-value">hours</tspan></text>
                                </g>
                                <g class="donut-text donut-small-text donut-text-3">
                                    <text transform="translate(0, 2)"><tspan x="35%" y="80%" text-anchor="middle" class="text-value">800</tspan><tspan x="35%" y="86%" text-anchor="middle" class="text-value">hours</tspan></text>
                                </g>
                            </svg>
                            <svg class="five-terms-layout" width="100%" height="115" viewBox="0 0 339 99" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="16.5" cy="14.9707" r="8" fill="#F8981C" />
                                <text y="53%" transform="translate(0, 2)">
                                    <tspan x="30%" y="19%" text-anchor="middle" class="donut-data-caption" fill="white">Term 1 Apprentice</tspan>
                                </text>
                                <circle cx="186.5" cy="14.9707" r="8" fill="#FAB760" />
                                <text y="53%" transform="translate(0, 2)">
                                    <tspan x="80%" y="22%" text-anchor="middle" class="donut-data-caption" fill="white">Term 2 Apprentice</tspan>
                                </text>
                                <circle cx="16.5" cy="49.9707" r="8" fill="#FCD6A4" />
                                <text y="53%" transform="translate(0, 2)">
                                    <tspan x="30%" y="55%" text-anchor="middle" class="donut-data-caption" fill="white">Term 3 Apprentice</tspan>
                                </text>
                                <circle cx="186.5" cy="49.9707" r="8" fill="white" />
                                <text y="53%" transform="translate(0, 2)">
                                    <tspan x="80%" y="57%" text-anchor="middle" class="donut-data-caption" fill="white">Term 4 Apprentice</tspan>
                                </text>
                 
                            </svg>
                        </div>
                    </div>
                </>
            )

        }

        const renderInSchoolChartOfSecondWorker = () => {
            return (
                <>
                    <div className='chart-layout-box'>
                        <div class="svg-item">
                            <svg width="100%" height="100%" viewBox="0 0 40 40" class="donut">
                                <circle class="donut-hole" cx="20" cy="20" r="15.91549430918954" fill="#003F72"></circle>
                                <circle class="donut-ring" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5" stroke-dashoffset="25"></circle>
                                <circle class="donut-segment donut-segment-5 donut-segment-51" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5" stroke-dasharray="69 31" stroke-dashoffset="-10"></circle>
                                <g class="donut-text donut-text-1">
                                    <text y="45%" transform="translate(0, 2)"><tspan x="50%" text-anchor="middle" class="donut-percent" fill="white">480</tspan></text>
                                    <text y="53%" transform="translate(0, 2)"><tspan x="50%" text-anchor="middle" class="donut-data" fill="white">Hours in-school</tspan></text>
                                </g>
                                <g class="donut-text donut-text-2">
                                    <text transform="translate(0, 2)"><tspan x="86%" y="30%" text-anchor="middle" class="text-value">40%</tspan></text>
                                </g>
                                <g class="donut-text donut-text-3">
                                    <text transform="translate(0, 2)"><tspan x="12%" y="60%" text-anchor="middle" class="text-value">60%</tspan></text>
                                </g>
                            </svg>

                            <svg class="donut-caption" width="100%" height="60" viewBox="0 0 287 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="16" cy="14.9941" r="8" fill="#F8981C" />
                                <text><tspan x="33%" y="70%" text-anchor="middle" class="text-value-school" fill="white" >In the classroom</tspan></text>
                                <circle cx="178" cy="14.9941" r="8" fill="white" />
                                <text><tspan x="83%" y="70%" text-anchor="middle" class="text-value-school" fill="white" >On the tools</tspan></text>
                            </svg>
                        </div>
                    </div>
                </>
            )
        }

        const renderSecondWorkerDetailsControls = () => {
            return (
                <>
                    <div className='button-grp-layout'>
                        {
                            (activeIndex !== 'In-School' && activeIndex !== 'OnTheJob') &&
                            <>
                                <button className='in-school-btn' onClick={this.clickHandler('In-School')}>
                                    In-school <img src="/image/btn-arrow-chart.svg" alt="Arrow"></img>
                                </button>
                                <button className='in-job-btn' onClick={this.clickHandler('OnTheJob')}>
                                    On-the-job <img src="/image/btn-arrow-chart.svg" alt="Arrow"></img>
                                </button>
                            </>
                        }
                        <div>
                            {
                                activeIndex === 'In-School' &&
                                <>
                                    <div className='back-btn-hours-box'>
                                        <button className='in-back-btn' onClick={this.clickHandler('')}>
                                            <img src="/image/btn-arrow-chart.svg" alt="Arrow" /> Back
                                        </button>
                                    </div>
                                    {renderInSchoolChartOfSecondWorker()}
                                </>
                            }
                            {
                                activeIndex === 'OnTheJob' &&
                                <>
                                    <div className='back-btn-hours-box'>
                                        <button className='in-back-btn' onClick={this.clickHandler('')}>
                                            <img src="/image/btn-arrow-chart.svg" alt="Arrow" /> Back
                                        </button>
                                    </div>
                                    {renderOnTheJobChartOfSecondWorker()}
                                </>
                            }
                        </div>
                    </div>

                    {/* chart code */}
                    {
                        (activeIndex !== 'In-School' && activeIndex !== 'OnTheJob') &&
                        <>
                            <div className='chart-layout-box'>
                                <div class="svg-item apprenticeship-donut">
                                    <svg width="100%" height="353" viewBox="0 0 40 40" class="donut">
                                        <circle class="donut-hole" cx="20" cy="20" r="15.91549430918954" fill="#003F72"></circle>
                                        <circle class="donut-ring" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5"></circle>
                                        <circle class="donut-segment donut-segment-2" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5" stroke-dasharray="69 31" stroke-dashoffset="25"></circle>
                                        <g class="donut-text donut-text-1">
                                            <text y="45%" transform="translate(0, 2)">
                                                <tspan x="50%" text-anchor="middle" class="donut-percent" fill="white">3980</tspan>
                                            </text>
                                            <text y="53%" transform="translate(0, 2)">
                                                <tspan x="50%" text-anchor="middle" class="donut-data" fill="white">Apprenticeship -</tspan>
                                                <tspan x="50%" y="60%" text-anchor="middle" class="donut-data" fill="white">Total Hours</tspan>
                                            </text>
                                        </g>
                                        <g class="donut-text donut-text-2">
                                            <text transform="translate(0, 2)"><tspan x="31%" y="8%" text-anchor="middle" class="text-value">480</tspan><tspan x="31%" y="15%" text-anchor="middle" class="text-value">hours</tspan></text>
                                        </g>
                                        <g class="donut-text donut-text-3">
                                            <text transform="translate(0, 2)"><tspan x="68%" y="79%" text-anchor="middle" class="text-value">3500</tspan><tspan x="68%" y="86%" text-anchor="middle" class="text-value">hours</tspan></text>
                                        </g>
                                    </svg>
                                </div>
                            </div>
                        </>
                    }
                </>
            )
        }

        /* First worker's chart */

        const renderOnTheJobChartOfFirstWorker = () => {
            return (
                <>
                    <div className='chart-layout-box'>
                        <div class="svg-item job-donut job-donut-one">
                            <svg width="100%" height="100%" viewBox="0 0 40 40" class="donut"><circle class="donut-hole" cx="20" cy="20" r="15.91549430918954" fill="#003F72"></circle><circle class="donut-segment donut-segment-1" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5" stroke-dasharray="100, 30" stroke-dashoffset="25"></circle><circle class="donut-segment donut-segment-main-2" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5" stroke-dasharray="45, 50" stroke-dashoffset="25"></circle><circle class="donut-segment donut-segment-3" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5" stroke-dasharray="69 31" stroke-dashoffset="25"></circle><g class="donut-text donut-text-1"><text y="45%" transform="translate(0, 2)"><tspan x="50%" text-anchor="middle" class="donut-percent" fill="white">2400</tspan></text><text y="53%" transform="translate(0, 2)"><tspan x="50%" text-anchor="middle" class="donut-data" fill="white">Hours on-the-job</tspan></text></g><g class="donut-text donut-text-2"><text transform="translate(0, 2)"><tspan x="13%" y="30%" text-anchor="middle" class="text-value">800</tspan><tspan x="12%" y="37%" text-anchor="middle" class="text-value">hours</tspan></text></g><g class="donut-text donut-text-3"><text transform="translate(0, 2)"><tspan x="83%" y="21%" text-anchor="middle" class="text-value">800</tspan><tspan x="83%" y="27%" text-anchor="middle" class="text-value">hours</tspan></text></g><g class="donut-text donut-text-4"><text transform="translate(4, 2)"><tspan x="50%" y="84%" text-anchor="middle" class="text-value">800</tspan><tspan x="50%" y="90%" text-anchor="middle" class="text-value">hours</tspan></text></g></svg>
                            <svg class="donut-bottom-text" width="auto" height="100%" viewBox="0 0 339 99" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="16.5" cy="45.9707" r="8" fill="#F8981C"></circle>
                                <text y="53%" transform="translate(0, 2)"><tspan x="30%" y="49%" text-anchor="middle" class="donut-data-caption" fill="white">Term 1 Apprentice</tspan></text>
                                <circle cx="186.5" cy="46.9707" r="8" fill="white"></circle>
                                <text y="53%" transform="translate(0, 2)"><tspan x="80%" y="50%" text-anchor="middle" class="donut-data-caption" fill="white">Term 2 Apprentice</tspan></text>
                                <circle cx="103" cy="80.9707" r="8" fill="#f9b660"></circle>
                                <text y="80%" transform="translate(0, 2)"><tspan x="55%" y="84.9707" text-anchor="middle" class="donut-data-caption" fill="white">Term 3 Apprentice</tspan></text>
                            </svg>
                        </div>
                    </div>
                </>
            )

        }

        const renderInSchoolChartOfFirstWorker = () => {
            return (
                <>
                    <div className='chart-layout-box'>
                        <div class="svg-item">
                            <svg width="100%" height="100%" viewBox="0 0 40 40" class="donut">
                                <circle class="donut-hole" cx="20" cy="20" r="15.91549430918954" fill="#003F72"></circle>
                                <circle class="donut-ring" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5" stroke-dashoffset="25"></circle>
                                <circle class="donut-segment donut-segment-5 donut-segment-51" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5" stroke-dasharray="69 31" stroke-dashoffset="-10"></circle>
                                <g class="donut-text donut-text-1">
                                    <text y="45%" transform="translate(0, 2)">
                                        <tspan x="50%" text-anchor="middle" class="donut-percent" fill="white">480</tspan>
                                    </text>
                                    <text y="53%" transform="translate(0, 2)">
                                        <tspan x="50%" text-anchor="middle" class="donut-data" fill="white">Hours in-school</tspan>
                                    </text>
                                </g>
                                <g class="donut-text donut-text-2">
                                    <text transform="translate(0, 2)"><tspan x="86%" y="30%" text-anchor="middle" class="text-value">40%</tspan></text>
                                </g>
                                <g class="donut-text donut-text-3">
                                    <text transform="translate(0, 2)"><tspan x="12%" y="60%" text-anchor="middle" class="text-value">60%</tspan></text>
                                </g>
                            </svg>
                            <svg class="donut-caption" width="100%" height="100%" viewBox="0 0 287 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="16" cy="14.9941" r="8" fill="#F8981C" />
                                <text><tspan x="33%" y="70%" text-anchor="middle" class="text-value-school" fill="white" >In the classroom</tspan></text>
                                <circle cx="178" cy="14.9941" r="8" fill="white" />
                                <text><tspan x="83%" y="70%" text-anchor="middle" class="text-value-school" fill="white" >On the tools</tspan></text>
                            </svg>
                        </div>
                    </div>
                </>
            )
        }

        const renderFirstWorkerDetailsControls = () => {
            return (
                <>
                    <div className='button-grp-layout'>
                        {
                            (activeIndex !== 'In-School' && activeIndex !== 'OnTheJob') &&
                            <>
                                <button className='in-school-btn' onClick={this.clickHandler('In-School')}>
                                    In-school <img src="/image/btn-arrow-chart.svg" alt="Arrow"></img>
                                </button>
                                <button className='in-job-btn' onClick={this.clickHandler('OnTheJob')}>
                                    On-the-job <img src="/image/btn-arrow-chart.svg" alt="Arrow"></img>
                                </button>
                            </>
                        }
                        <div>
                            {
                                activeIndex === 'In-School' &&
                                <>
                                    <div className='back-btn-hours-box'>
                                        <button className='in-back-btn' onClick={this.clickHandler('')}>
                                            <img src="/image/btn-arrow-chart.svg" alt="Arrow" /> Back
                                        </button>
                                    </div>
                                    {renderInSchoolChartOfFirstWorker()}
                                </>
                            }
                            {
                                activeIndex === 'OnTheJob' &&
                                <>
                                    <div className='back-btn-hours-box'>
                                        <button className='in-back-btn' onClick={this.clickHandler('')}>
                                            <img src="/image/btn-arrow-chart.svg" alt="Arrow" /> Back
                                        </button>
                                    </div>
                                    {renderOnTheJobChartOfFirstWorker()}
                                </>
                            }
                        </div>
                    </div>

                    {/* chart code */}
                    {
                        (activeIndex !== 'In-School' && activeIndex !== 'OnTheJob') &&
                        <>
                            <div className='chart-layout-box'>
                                <div class="svg-item apprenticeship-donut">
                                    <svg width="100%" height="353" viewBox="0 0 40 40" class="donut">
                                        <circle class="donut-hole" cx="20" cy="20" r="15.91549430918954" fill="#003F72"></circle>
                                        <circle class="donut-ring" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5"></circle>
                                        <circle class="donut-segment donut-segment-2" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="7.5" stroke-dasharray="69 31" stroke-dashoffset="25"></circle>
                                        <g class="donut-text donut-text-1">
                                            <text y="45%" transform="translate(0, 2)">
                                                <tspan x="50%" text-anchor="middle" class="donut-percent" fill="white">2880</tspan>
                                            </text>
                                            <text y="53%" transform="translate(0, 2)">
                                                <tspan x="50%" text-anchor="middle" class="donut-data" fill="white">Apprenticeship -</tspan>
                                                <tspan x="50%" y="60%" text-anchor="middle" class="donut-data" fill="white">Total Hours</tspan>
                                            </text>
                                        </g>
                                        <g class="donut-text donut-text-2">
                                            <text transform="translate(0, 2)"><tspan x="31%" y="8%" text-anchor="middle" class="text-value">480</tspan><tspan x="31%" y="15%" text-anchor="middle" class="text-value">hours</tspan></text>
                                        </g>
                                        <g class="donut-text donut-text-3">
                                            <text transform="translate(0, 2)"><tspan x="68%" y="79%" text-anchor="middle" class="text-value">2400</tspan><tspan x="68%" y="86%" text-anchor="middle" class="text-value">hours</tspan></text>
                                        </g>
                                    </svg>
                                </div>
                            </div>
                        </>
                    }
                </>
            )
        }

        return (
            <>
                {(selectedDoughnut === '1') && renderFirstWorkerDetailsControls()}
                {(selectedDoughnut === '2') && renderSecondWorkerDetailsControls()}
                {(selectedDoughnut === '3') && renderThirdWorkerDetailsControls()}
                {(selectedDoughnut === '4') && renderForthWorkerDetailsControls()}
                {(selectedDoughnut === '5') && renderFifthWorkerDetailsControls()}
                {(selectedDoughnut === '6') && renderSixWorkerDetailsControls()}
            </>
        )
    }
}
